import React, {useEffect, useRef} from "react";
import {locations} from "../../Utilities/Location";
import {userApi} from "../User/userApi";
import {handleApiCall} from "../../Utilities/Api/callbackUtilities";

interface SignOutContainerProps {
    redirect: (path: string) => void;
    setLoggedInFalse: () => boolean;
}

export function SignOutContainer ({redirect, setLoggedInFalse}: SignOutContainerProps) {
    const didRun = useRef(false);

    useEffect(() => {
        if (didRun.current) return;
        didRun.current = true;

        setLoggedInFalse();
        handleApiCall(() => userApi.attemptLogout());
        redirect(locations.LANDING.path);
    }, [redirect, setLoggedInFalse]);

    return <p>You have been successfully signed out. If you are not redirected you can close this page anytime.</p>;
}
